export default {
	pass: '',
	perfil: 28,
	uid: {
		cpf: '',
		departamento: 15,
		empresa: '',
		funcao: '',
		nome: '',
		registro: '',
		sobrenome: '',
		telefone: '',
	},
	user: '',
	avatar: '',
	type: 'ENFGESTOR',
	carteira: [],
	comissao: '-1',
	enderecos: [],
	metadata: [
		{ id: 'mtd_tCliented', value: '', cod_form: 10 },
		{ id: 'mtd_rTecnico', value: '', cod_form: 10 },
		{ id: 'mtd_qTecnica', value: 'TST', cod_form: 10 },
	],
	sst_id: 0,
};



// WEBPACK FOOTER //
// ./src/components/settings/users/modal/reset.js